import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({

    // Barra de opcion

    dir: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    back_home: {
        paddingLeft: "10px",
        maxWidth: "20px",
    },
    back_home_container: {
        maxWidth: '60px',
        minWidth: '60px',
        maxHeight: '35px',
        minHeight: '35px'
    },
    title: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000c4)",
        margin: "20px"
    },

    // Preferences
    main: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    preferences_paper: {
        margin: "8px auto",
        width: "800px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "20px 40px"
    },
    preferences_paper_center: {
        margin: "8px auto",
        width: "800px",
        display: "flex",
        flexDirection: "column",
        padding: "20px 40px",
    },
    ventajas_title: {
        alignSelf: "center"
    },
    table: {
        width: "750px",
        textAlign: "center",
        margin: "auto"
    },
    row_header: {
        width: "145px"
    },
    row_title: {
        textAlign: "right",
        height: "30px",
        paddingRight: "15px"
    },
    buy_tr: {
        marginTop: "100px",
        height: "80px"
    },
    logout: {
        margin: "25px auto",
    },
    checkIcon: {
        color: "#40d668",
        filter: "drop-shadow(1px 1px 1px #000000c4)",
    },
    clearIcon: {
        color: "#ab1f1f"
    },
    contacta: {
        textAlign: "center"
    },
    font_select: {
        fontSize: "18px"
    },
    lorem_title: {
        margin: "20px 0px -3px"
    },
    background_buttons: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        margin: "0px auto 25px",
    },
    background_button: {
        width: "165px",
        height: "165px",
        backgroundSize: "200px",
        margin: "10px"
    },
    lock_icon: {
        color: "red",
        border: "1px solid red",
        borderRadius: "25px",
        padding: "10px"
    },
    lock_button: {
        alignSelf: "center"
    },
    full_hr: {
        width: "90%"
    },
    lang_select: {
        width: "120px",
        height: "30px",
        padding: "0px 10px",
        borderRadius: "20px",
        fontSize: "16px",
        fontWeight: "bold",
        filter: "drop-shadow(1px 1px 1px #000000c4)",
        outline: "none"
    },
    legal: {
        fontSize: "12px",
        color: "#757575"
    },
    visibility_icon: {
        color: "#ffffff"
    },
    free_warning: {
        fontSize: "25px",
        lineHeight: "45px"
    },
    unlock_button: {
        width: "150px",
        alignSelf: "center"
    },
    account_benefits_h3: {
        marginBottom: "7px",
    },
    h2: {
        fontSize: "27px"
    }
}))